import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import { Modal, Button } from "react-bootstrap";
import "./Spinner.css";
import { useNavigate } from "react-router";
import "./hm-theme.css";

const AddDocument = ({ isOpen, onRequestClose, id }) => {
  const [document, setDocuments] = useState({
    id: id || null,
    file: null,
    fileMeta: "",
    fileName: "",
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const url = id ? `/api/documentation/update` : "/api/documentation/create";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!document.file) {
      toast.warn("Please select a file to upload.");
      return;
    }
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;

    const documentData = {
      id: id || null,
      file: document.file,
      fileMeta: document.fileMeta,
      fileName: document.fileName,
    };

    try {
      await axios.post(url, documentData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(id ? "Document updated successfully" : "Document uploaded successfully");
      setLoading(false);
      onRequestClose();
      resetForm();
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const resetForm = () => {
    setDocuments({ file: null, fileMeta: "", fileName: "", id: null });
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  function getBase64FromFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const [metadata, content] = reader.result.split(",");
        resolve({ metadata, content });
      };
      reader.onerror = (error) => reject(error);
    });
  }

  const handlePdfFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const convertedPdf = await getBase64FromFile(file);
      setDocuments({
        ...document,
        file: convertedPdf.content,
        fileName: file.name,
        fileMeta: convertedPdf.metadata,
      });
    }
  };

  useEffect(() => {
    if (id) {
      setDocuments((prev) => ({ ...prev, id }));
    }
  }, [id]);

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">upload_file</i>
          {id ? "Update Document" : "Upload Document"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="file" className="form-label small fw-semibold">
              Select Document File <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="file"
              type="file"
              onChange={handlePdfFileChange}
              required={!id}
            />
            {document.fileName && (
              <span className="small text-muted mt-1 d-block">
                Selected: <strong>{document.fileName}</strong>
              </span>
            )}
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>{id ? "edit" : "upload"}</i>
              {id ? "Update Document" : "Upload Document"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddDocument;